module.exports = __webpack_public_path__ + "static/media/Medical.2b8d8ba6.svg";